import { __awaiter, __generator } from "tslib";
import { isBrowser, isNode, isWebWorker } from './env-util';
// Inlined from https://github.com/sindresorhus/is-absolute-url/blob/main/index.js
export function isAbsoluteUrl(url) {
    if (typeof url !== 'string') {
        throw new TypeError("Expected a `string`, got `" + typeof url + "`");
    }
    // Don't match Windows paths `c:\`
    if (/^[a-zA-Z]:\\/.test(url)) {
        return false;
    }
    // Scheme: https://tools.ietf.org/html/rfc3986#section-3.1
    // Absolute URL: https://tools.ietf.org/html/rfc3986#section-4.3
    return /^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(url);
}
export function silent(fn) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fn()];
                case 1:
                    _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function extractProp(data, path) {
    return path
        .split('.')
        .filter(function (prop) { return prop; })
        .reduce(function (result, prop) { return result[prop]; }, data);
}
export function extractHost(url) {
    return new URL(url).host;
}
export function changeHost(urlOrPath, host) {
    var url;
    try {
        url = new URL(urlOrPath);
        url.host = host;
    }
    catch (_a) {
        url = new URL("http://" + host);
        url.pathname = urlOrPath;
    }
    return url.toString();
}
export function getGlobalConfig() {
    var defaultConfig = { httpMockServer: { enabled: false } };
    var globalConfig;
    if (isBrowser()) {
        globalConfig = window._httpClientGlobalConfig;
    }
    else if (isNode()) {
        try {
            globalConfig = JSON.parse(process.env.HTTP_CLIENT_GLOBAL_CONFIG);
        }
        catch (e) { }
    }
    else if (isWebWorker()) {
        // TODO
    }
    return globalConfig || defaultConfig;
}
export function isHttpMockServerEnabled() {
    var globalConfig = getGlobalConfig();
    return globalConfig.httpMockServer.enabled;
}
//# sourceMappingURL=utils.js.map